import { graphHooks } from '@tunasong/graph-lib/react'
import type { AudioMedia } from '@tunasong/schemas'
import { isEntityClip } from '@tunasong/schemas'
import type { Ref } from 'react'
import { usePeaks } from '../../hooks/index.js'
import { Wave } from '../../waveform/wave.js'
import { type ClipProps } from './clip-container.js'
import { WaveContainer } from './clip.styles.js'

export interface EntityClipProps extends ClipProps {
  className?: string
  ref?: Ref<HTMLDivElement>
}

const EntityClip = (props: EntityClipProps) => {
  const { className, clip, ref } = props

  if (!isEntityClip(clip)) {
    throw new Error(`EntityClip component used for different clip type ${clip.type}`)
  }

  const { entity: media } = graphHooks.useEntity<AudioMedia>(clip.entityId)

  const { peaks } = usePeaks({ media, renderPeaks: true })

  if (!clip) {
    return null
  }

  return (
    <div className={className} ref={ref}>
      <Wave component={WaveContainer} peaks={peaks} position={0} />
    </div>
  )
}

export default EntityClip
